var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.732 3H18l1 1-1 1h-1.268a2 2 0 01-3.464 0H2L1 4l1-1h11.268a2 2 0 013.464 0zM4.268 9H2l-1 1 1 1h2.268a2 2 0 003.464 0H18l1-1-1-1H7.732a2 2 0 00-3.464 0zM2 15h7.268a2 2 0 013.464 0H18l1 1-1 1h-5.268a2 2 0 01-3.464 0H2l-1-1 1-1z",
    fill: "#9A9CAC"
  })));
}

export default SvgFilterIcon;